import { useEffect } from 'react'
import { loadFont } from '../font'

export default function useFont() {
	useEffect(() => {
		loadFont().then((fonts) => {
			for (const font of fonts) {
				document.fonts.add(font)
			}
		})
	}, [])
}
